import styled from 'styled-components';
import { s } from '../../pay/pay.style';

interface DetailHistory {
  std_prc: number;
  is_discount: string;
  description: string;
  discount_amount: number;
  total_prc: number;
  good_name: string;
  order_id: string;
  plan_id: string;
  method: string;
  card_bank: string;
  installment: number;
  created_at: string;
  appl_num: number;
  account_num: string;
  bank_name: string;
  account_holder: string;
  input_date: string;
  input_time: string;
}

interface ReceiptProps {
  onClose: () => void;
  detailHistory: DetailHistory;
}

const Receipt = ({ onClose, detailHistory }: ReceiptProps) => {
  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <img
            src="/assets/images/logo/zipgoai_logo_mobile_drawer.svg"
            alt=""
          />
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="Close"
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            onClick={onClose}
          />
        </Header>
        <Content>
          <div style={{ fontSize: '18px', fontWeight: '700' }}>결제 영수증</div>
          <GrayLine />
        </Content>
        <Content>
          <Row>
            <s.Span50014Light>결제이용자</s.Span50014Light>
            <s.Div50016>{localStorage.getItem('userName')}</s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>결제일시</s.Span50014Light>
            <s.Div50016>
              {detailHistory.created_at.replaceAll('-', '.')}
            </s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>주문번호</s.Span50014Light>
            <s.Div50016>{detailHistory.order_id}</s.Div50016>
          </Row>
          <GrayLine />
        </Content>
        <Content>
          <Row>
            <s.Span50014Light>구매상품</s.Span50014Light>
            <s.Div50016>{detailHistory.good_name}</s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>기본 상품 금액</s.Span50014Light>
            <s.Div50016>
              {detailHistory.std_prc.toLocaleString('ko-KR')}원
            </s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>할인 금액</s.Span50014Light>
            <s.Div50016>
              {detailHistory?.is_discount === 'Y' ? (
                <div className="discount-column">
                  <span>
                    {detailHistory.good_name.includes('바른NPL')
                      ? '바른NPL 50% 할인'
                      : detailHistory.good_name.includes('얼리버드')
                        ? '얼리버드 50% 할인'
                        : '50% 할인'}
                  </span>
                  <br />
                  <span>
                    (-{detailHistory?.discount_amount.toLocaleString('ko-KR')}
                    원)
                  </span>
                </div>
              ) : (
                <>{detailHistory?.discount_amount.toLocaleString('ko-KR')}원</>
              )}
            </s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light style={{ color: '#008AFF' }}>
              총 결제 금액
            </s.Span50014Light>
            <s.Div50016 style={{ color: '#008AFF' }}>
              {detailHistory.total_prc.toLocaleString('ko-KR')}원
            </s.Div50016>
          </Row>
          <GrayLine />
        </Content>
        <Content>
          <Row>
            <s.Span50014Light>결제수단</s.Span50014Light>
            <s.Div50016>{detailHistory.method}</s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>결제카드</s.Span50014Light>
            <s.Div50016>
              {detailHistory.method === '신용카드'
                ? detailHistory.card_bank
                : '-'}
            </s.Div50016>
          </Row>
          <Row>
            <s.Span50014Light>할부기간</s.Span50014Light>
            <s.Div50016>
              {detailHistory?.method === '신용카드' ? (
                detailHistory.installment === 0 ? (
                  <span>일시불</span>
                ) : (
                  <span>{detailHistory.installment}개월</span>
                )
              ) : (
                <span>-</span>
              )}
            </s.Div50016>
          </Row>
          {/* <Row>
            <s.Span50014Light>결제상태</s.Span50014Light>
            <s.Div50016>detailHistory api에 결제 상태 추가?</s.Div50016>
          </Row> */}
          <Row>
            <s.Span50014Light>승인번호</s.Span50014Light>
            <s.Div50016>
              {detailHistory.method === '신용카드'
                ? detailHistory.appl_num
                : '-'}
            </s.Div50016>
          </Row>
          <GrayLine />
        </Content>
        <Content style={{ marginTop: '24px' }}>
          <s.Div50016Light>
            <span>
              * 본 거래내역에 대한 정보는 법적 효력이 없으며 단순 참고용으로
              활용할 수 있습니다.
            </span>
            <span>
              * 본 확인증의 내용을 임의로 수정하여 행사할 경우 법에 저촉될 수
              있습니다.
            </span>
          </s.Div50016Light>
          <Bottom>
            <s.Div70014>이용상점</s.Div70014>
            <s.Div50016Light>
              트랜스파머(주) | 대표자명: 김기현 | 사업자등록번호: 507-87-02631 |
              전화: 02-555-2822 | 주소: (본점)강원특별자치도 춘천시 춘천로 188,
              210-C75호 / (지점)서울특별시 서초구 매헌로 24 NH농협
              디지털혁신캠퍼스 5층
            </s.Div50016Light>
          </Bottom>
        </Content>
      </ModalContainer>
    </Overlay>
  );
};

export default Receipt;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding-top: env(safe-area-inset-top);
  align-items: stretch;
`;

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 내용 넘치면 스크롤 */
  padding: 40px 16px;
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  /* 모바일에서 스크롤 부드럽게 */
  -webkit-overflow-scrolling: touch;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GrayLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e8ea;
  margin-bottom: 16px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
